export const SM_PROGRAM_ID = 2;
export const APP_NAME = "stadium";
